import actionTypes from '../actionTypes';
import {
	currencyFormatter,
	percentageFormatter,
	numericalComparator,
	decimalSeparator,
} from '../utils';

export const initialState = {
	tableRows: [],
	tableColumns: [],
	isLoading: true,
	isError: false,
	isSuccess: true,
	departmentTableRows: [],
	categoryTableRows: [],
	subcategoryTableRows: [],
	departmentTotal: 0,
	categoryTotal: 0,
	subcategoryTotal: 0,
	departmentPositiveItems: 0,
	categoryPositiveItems: 0,
	subcategoryPositiveItems: 0,
	departmentNegativeItems: 0,
	categoryNegativeItems: 0,
	subcategoryNegativeItems: 0,
	supplierShare: {},
	deptAnomalies: [],
	catAnomalies: [],
	subCatAnomalies: [],
	departmentColumns: [
		{
			sortable: true,
			field: 'name',
			headerName: 'Department Name',
			pinned: 'left',
			cellClass: ['pointer', 'left-aligned-text', 'pinned-column'],
		},
		{
			sortable: true,
			field: 'marketShare',
			headerName: 'Supplier Dollar Share',
			type: 'numericColumn',
			cellClass: ['pointer', 'right-aligned-text'],
			valueFormatter: percentageFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'supplierShare',
			},
		},
		{
			sortable: true,
			field: 'marketShareChng',
			filter: 'agNumberColumnFilter',
			headerName: 'Supplier Dollar Share Chg',
			type: 'numericColumn',
			cellClass: ['pointer', 'right-aligned-text'],
			cellRenderer: 'customShareChgComponent',
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'supplierShareChng',
			},
		},
		{
			sortable: true,
			field: 'netSalesTY',
			headerName: 'Net Sales',
			type: 'numericColumn',
			cellClass: ['pointer', 'right-aligned-text'],
			valueFormatter: currencyFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsales',
			},
		},
		{
			sortable: true,
			field: 'netSalesTYChngRef',
			headerName: 'Net Sales $ Chg',
			cellClass: ['pointer', 'right-aligned-text'],
			type: 'numericColumn',
			valueFormatter: currencyFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsalesDollarChng',
			},
		},
		{
			sortable: true,
			field: 'netSalesTYChngPctRef',
			headerName: 'Net Sales % Chg',
			cellClass: ['pointer', 'right-aligned-text'],
			type: 'numericColumn',
			valueFormatter: percentageFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsalesPercentChng',
			},
		},
		{
			sortable: true,
			field: 'unitsTY',
			headerName: 'Units',
			cellClass: ['pointer', 'right-aligned-text'],
			type: 'numericColumn',

			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'unitsSold',
			},
			valueFormatter: decimalSeparator,
		},
		{
			sortable: true,
			field: 'unitsTYChngRef',
			headerName: 'Units Chg',
			cellClass: ['pointer', 'right-aligned-text'],
			type: 'numericColumn',

			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'unitsSoldChng',
			},
			valueFormatter: decimalSeparator,
		},
		{
			sortable: true,
			field: 'unitsTYChngPctRef',
			headerName: 'Units % Chg',
			cellClass: ['pointer', 'right-aligned-text'],
			type: 'numericColumn',
			valueFormatter: percentageFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'unitsSoldPercentChng',
			},
		},
		{
			sortable: true,
			field: 'rcaTags',
			filter: 'agSetColumnFilter',
			headerName: 'Root Cause',
			cellClass: ['pointer', 'left-aligned-text-special'],
			cellRenderer: 'rcaCellComponent',
			minWidth: 373,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'rootCause',
				leftAlign: true,
			},
		},
	],
	categoryColumns: [
		{
			sortable: true,
			field: 'name',
			headerName: 'Category Name',
			cellClass: ['pointer', 'left-aligned-text'],
		},
		{
			sortable: true,
			field: 'marketShare',
			type: 'numericColumn',
			headerName: 'Supplier Dollar Share',
			cellClass: ['pointer', 'right-aligned-text'],
			valueFormatter: percentageFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'supplierShare',
			},
		},
		{
			sortable: true,
			filter: 'agNumberColumnFilter',
			field: 'marketShareChng',
			type: 'numericColumn',
			headerName: 'Supplier Dollar Share Chg',
			cellClass: ['pointer', 'right-aligned-text'],
			cellRenderer: 'customShareChgComponent',
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'supplierShareChng',
			},
		},
		{
			sortable: true,
			field: 'netSalesTY',
			type: 'numericColumn',
			headerName: 'Net Sales',
			cellClass: ['pointer', 'right-aligned-text'],
			valueFormatter: currencyFormatter,
			headerComponent: 'customColumnHeader',
			comparator: numericalComparator,
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsales',
			},
		},
		{
			sortable: true,
			field: 'netSalesTYChngRef',
			type: 'numericColumn',
			headerName: 'Net Sales $ Chg',
			cellClass: ['pointer', 'right-aligned-text'],
			valueFormatter: currencyFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsalesDollarChng',
			},
		},
		{
			sortable: true,
			field: 'netSalesTYChngPctRef',
			headerName: 'Net Sales % Chg',
			type: 'numericColumn',
			cellClass: ['pointer', 'right-aligned-text'],
			valueFormatter: percentageFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsalesPercentChng',
			},
		},
		{
			sortable: true,
			field: 'unitsTY',
			headerName: 'Units',
			cellClass: ['pointer', 'right-aligned-text'],
			type: 'numericColumn',
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsalesPercentChng',
			},
			valueFormatter: decimalSeparator,
		},
		{
			sortable: true,
			field: 'unitsTYChngRef',
			headerName: 'Units Chg',
			cellClass: ['pointer', 'right-aligned-text'],
			type: 'numericColumn',
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsalesPercentChng',
			},
			valueFormatter: decimalSeparator,
		},
		{
			sortable: true,
			field: 'unitsTYChngPctRef',
			headerName: 'Units % Chg',
			cellClass: ['pointer', 'right-aligned-text'],
			type: 'numericColumn',
			valueFormatter: percentageFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsalesPercentChng',
			},
		},
		{
			sortable: true,
			field: 'rcaTags',
			headerName: 'Root Cause',
			cellClass: ['pointer', 'left-aligned-text'],
			cellRenderer: 'rcaCellComponent',
			filter: 'agSetColumnFilter',
			minWidth: 373,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'rootCause',
				leftAlign: true,
			},
		},
	],
	subcategoryColumns: [
		{
			sortable: true,
			field: 'name',
			headerName: 'Sub-Category Name',
			cellClass: ['pointer', 'left-aligned-text'],
		},
		{
			sortable: true,
			field: 'marketShare',
			headerName: 'Supplier Dollar Share',
			type: 'numericColumn',
			cellClass: ['pointer', 'right-aligned-text'],
			valueFormatter: percentageFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'supplierShare',
			},
		},
		{
			sortable: true,
			field: 'marketShareChng',
			filter: 'agNumberColumnFilter',
			type: 'numericColumn',
			headerName: 'Supplier Dollar Share Chg',
			cellClass: ['pointer', 'right-aligned-text'],
			cellRenderer: 'customShareChgComponent',
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'supplierShareChng',
			},
		},
		{
			sortable: true,
			field: 'netSalesTY',
			headerName: 'Net Sales',
			type: 'numericColumn',
			cellClass: ['pointer', 'right-aligned-text'],
			valueFormatter: currencyFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsales',
			},
		},
		{
			sortable: true,
			field: 'netSalesTYChngRef',
			headerName: 'Net Sales $ Chg',
			type: 'numericColumn',
			cellClass: ['pointer', 'right-aligned-text'],
			valueFormatter: currencyFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsalesDollarChng',
			},
		},
		{
			sortable: true,
			field: 'unitsTY',
			headerName: 'Units',
			cellClass: ['pointer', 'right-aligned-text'],
			type: 'numericColumn',
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsalesPercentChng',
			},
			valueFormatter: decimalSeparator,
		},
		{
			sortable: true,
			field: 'unitsTYChngRef',
			headerName: 'Units Chg',
			cellClass: ['pointer', 'right-aligned-text'],
			type: 'numericColumn',
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsalesPercentChng',
			},
			valueFormatter: decimalSeparator,
		},
		{
			sortable: true,
			field: 'unitsTYChngPctRef',
			headerName: 'Units % Chg',
			cellClass: ['pointer', 'right-aligned-text'],
			type: 'numericColumn',
			valueFormatter: percentageFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsalesPercentChng',
			},
		},
		{
			sortable: true,
			field: 'netSalesTYChngPctRef',
			headerName: 'Net Sales % Chg',
			type: 'numericColumn',
			cellClass: ['pointer', 'right-aligned-text'],
			valueFormatter: percentageFormatter,
			comparator: numericalComparator,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'netsalesPercentChng',
			},
		},
		{
			sortable: true,
			field: 'rcaTags',
			headerName: 'Root Cause',
			cellClass: ['pointer', 'left-aligned-text'],
			cellRenderer: 'rcaCellComponent',
			filter: 'agSetColumnFilter',
			minWidth: 373,
			headerComponent: 'customColumnHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'rootCause',
				leftAlign: true,
			},
		},
	],
};

const anomalyDetectionReducer = (state = initialState, action = {}) => {
	switch (action?.type) {
		case actionTypes.GET_ANOMALY_DETECTION_DATA: {
			return {
				...state,
				isLoading: true,
				deptAnomalies: [],
				catAnomalies: [],
				subCatAnomalies: [],
				departmentTotal: 0,
				categoryTotal: 0,
				subcategoryTotal: 0,
				departmentPositiveItems: 0,
				categoryPositiveItems: 0,
				subcategoryPositiveItems: 0,
				departmentNegativeItems: 0,
				categoryNegativeItems: 0,
				subcategoryNegativeItems: 0,
				supplierShare: {},
				departmentTableRows: [],
				categoryTableRows: [],
				subcategoryTableRows: [],
				tableRows: [],
				tableColumns: state.departmentColumns,
			};
		}

		case actionTypes.GET_ANOMALY_DETECTION_DATA_SUCCESS: {
			return {
				...state,
				deptAnomalies: action.payload.deptAnomalies,
				catAnomalies: action.payload.catAnomalies,
				subCatAnomalies: action.payload.subCatAnomalies,
				departmentTotal: action.payload.departmentTotal,
				categoryTotal: action.payload.categoryTotal,
				subcategoryTotal: action.payload.subcategoryTotal,
				departmentPositiveItems: action.payload.departmentPositiveItems,
				categoryPositiveItems: action.payload.categoryPositiveItems,
				subcategoryPositiveItems: action.payload.subcategoryPositiveItems,
				departmentNegativeItems: action.payload.departmentNegativeItems,
				categoryNegativeItems: action.payload.categoryNegativeItems,
				subcategoryNegativeItems: action.payload.subcategoryNegativeItems,
				supplierShare: action.payload.supplierShare,
				departmentTableRows: action.payload.departmentTableRows,
				tableRows: action.payload.departmentTableRows,
				tableColumns: state.departmentColumns,
				isLoading: false,
				isSuccess: true,
			};
		}

		case actionTypes.GET_ANOMALY_DETECTION_DATA_FAILURE: {
			return {
				...state,
				isLoading: false,
				isError: true,
			};
		}

		case actionTypes.GET_ANOMALIES_SALES_METRICS: {
			return {
				...state,
				isLoading: true,
			};
		}

		case actionTypes.GET_ANOMALIES_SALES_METRICS_SUCCESS: {
			switch (action.payload.hierarchyLevel) {
				case 'DEPARTMENT':
					return {
						...state,
						tableColumns: state.departmentColumns,
						tableRows: action.payload.tableRows,
						departmentTableRows: action.payload.tableRows,
						isLoading: false,
					};
				case 'CATEGORY':
					return {
						...state,
						tableColumns: state.categoryColumns,
						tableRows: action.payload.tableRows,
						categoryTableRows: action.payload.tableRows,
						isLoading: false,
					};
				default:
					return {
						...state,
						tableColumns: state.subcategoryColumns,
						tableRows: action.payload.tableRows,
						subcategoryTableRows: action.payload.tableRows,
						isLoading: false,
					};
			}
		}

		case actionTypes.GET_ANOMALIES_SALES_METRICS_FAILURE: {
			return {
				...state,
				isLoading: false,
				tableRows: [],
				isError: true,
			};
		}

		case actionTypes.UPDATE_TABLE_ROWS_AND_COLUMNS: {
			switch (action.payload) {
				case 'DEPARTMENT':
					return {
						...state,
						tableColumns: state.departmentColumns,
						tableRows: state.departmentTableRows,
					};
				case 'CATEGORY':
					return {
						...state,
						tableColumns: state.categoryColumns,
						tableRows: state.categoryTableRows,
					};
				default:
					return {
						...state,
						tableColumns: state.subcategoryColumns,
						tableRows: state.subcategoryTableRows,
					};
			}
		}

		case actionTypes.RESET_AD_TABLE_ROWS: {
			return {
				...state,
				tableRows: [],
			};
		}

		default:
			return state;
	}
};

export default anomalyDetectionReducer;
